import PropTypes from 'prop-types';
import { CSVLink } from 'react-csv';

//
// QUESTION: Why does this component exist instead of just using the CSVLink from `react-csv` directly?
//           This component doesn't appear to add anything or make the developer experience any easier.
//
const CSVExporter = ({ data, headers, labelText, ...rest }) => (
  <CSVLink data={data} headers={headers} {...rest}>
    {labelText}
  </CSVLink>
);

CSVExporter.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  headers: PropTypes.arrayOf(PropTypes.object).isRequired,
  labelText: PropTypes.string.isRequired,
};

export default CSVExporter;
